export const BASE_URL =
"https://socialthoughts.onrender.com";

